import React from 'react';
import clsx from 'clsx';
import styles from './Button.module.scss';

const Button = ({ text, icon, onClick, variant = '', disabled = false, width, className }) => {
        return (
                <button
                        className={clsx(styles.button, styles[variant], className, {
                                [styles.disabled]: disabled,
                        })}
                        onClick={onClick}
                        style={{ width: width || 'auto' }}
                >
                        {icon && (
                                <img
                                        src={icon}
                                        alt="button-icon"
                                        className="w-5 h-5"
                                />
                        )}
                        {text}
                </button>
        );
};

export default Button;
